export default __webpack_public_path__ + "static/media/icon_purchase_num.b9bbd019.svg";